import {Controller, ControllerProps, FieldPath, FieldValues, ValidationRule} from 'react-hook-form';
import {FormHelperText} from '@mui/material';
import AppRadio, {AppRadioProps} from './AppRadio';

export type AppControlledRadioProps<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<AppRadioProps, 'name' | 'required'> &
    Omit<ControllerProps<TFieldValues, TName>, 'render'> & {
        required?: string | ValidationRule<boolean>;
    };

export function AppControlledRadio<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({name, control, rules, required, options, onChange, ...rest}: AppControlledRadioProps<TFieldValues, TName>) {
    return (
        <Controller
            name={name}
            rules={{required: required, ...rules}}
            control={control}
            {...rest}
            render={({field, fieldState: {invalid, error}}) => (
                <>
                    <AppRadio
                        // error={invalid}
                        options={options}
                        {...rest}
                        {...field}
                        onChange={(event, child) => {
                            if (onChange) {
                                onChange(event, child);
                            }
                            field.onChange(event, child);
                        }}
                    />
                    <FormHelperText>{error?.message && 'Error Found'}</FormHelperText>
                </>
            )}
        />
    );
}

export default AppControlledRadio;
